module.exports = __webpack_public_path__ + "static/img/goback.caaed97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/goback.png
// module id = vr21
// module chunks = 1